import React from 'react';
import { Volume2, Download, X as XIcon } from 'lucide-react';

/**
 * Floating MP3 player rendered top-right while a TTS narration is loaded.
 * Pure presentational — parent owns audio element via `audioRef`.
 */
export default function DemoAudioPlayer({
  audioRef,
  lastAudioUrl,
  ttsVoice,
  onDownload,
  onClose,
}) {
  if (!lastAudioUrl) return null;
  return (
    <div
      className="fixed top-4 right-4 z-[55] flex items-center gap-2 rounded-xl border border-fuchsia-200 bg-white/95 px-3 py-2 shadow-xl backdrop-blur"
      data-testid="demo-audio-player"
    >
      <Volume2 className="h-4 w-4 text-fuchsia-600" />
      <span className="text-[10px] font-semibold uppercase tracking-wider text-fuchsia-700">
        {ttsVoice}
      </span>
      <audio
        ref={audioRef}
        src={lastAudioUrl}
        controls
        className="h-8 w-64"
        data-testid="demo-audio-element"
      >
        <track kind="captions" />
      </audio>
      <button
        onClick={onDownload}
        className="rounded-md p-1.5 text-fuchsia-700 transition-colors hover:bg-fuchsia-50"
        title="Download MP3"
        data-testid="demo-audio-download-btn"
      >
        <Download className="h-4 w-4" />
      </button>
      <button
        onClick={onClose}
        className="rounded-md p-1.5 text-slate-500 transition-colors hover:bg-slate-100"
        title="Close player"
        data-testid="demo-audio-close-btn"
      >
        <XIcon className="h-4 w-4" />
      </button>
    </div>
  );
}
